import type { FeatureFlagsQuery_featureFlags_nodes } from './__types__/FeatureFlagsQuery.ts';

/**
 * NOTE:
 * This file is used in query preloader aggregator.
 * In order to keep the bundle size to the minimum.
 * This file should not depend on any other packages.
 * All exports should be pure function.
 */

export function unwrapValue(value: any): string | boolean {
	if (value === 'true') {
		return true;
	} else if (value === 'false') {
		return false;
	} else if (typeof value === 'object') {
		return JSON.stringify(value);
	}

	return value;
}

export function keyById<TObject extends { id: string }, TValue>(
	objectList: TObject[],
	valueGetter: (item: TObject) => TValue,
): {
	[objectId: string]: TValue;
} {
	return objectList.reduce<{ [objectId: string]: TValue }>((keyedObject, item) => {
		keyedObject[item.id] = valueGetter(item);
		return keyedObject;
	}, {});
}

export const processFeatureFlagsPure = (
	flags: FeatureFlagsQuery_featureFlags_nodes[],
): {
	[objectId: string]: string | boolean;
} => {
	return keyById(flags, (item) => unwrapValue(item.value));
};
